// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"fd13e2a8","229":"b2d1560e","481":"0874a26e","489":"87092d36","509":"7c1912f1","563":"7a5a1f52","602":"662919a0","605":"b50b36c9","754":"8bd27d41","776":"3b6902e8","933":"87681953"}[chunkId] + ".css";
};